module.exports = __webpack_public_path__ + "static/media/Imaryuk9.a667371e.jpg";